import { defineComponent as _defineComponent } from 'vue'
import { ref } from "vue";
import VueDraggable from "vuedraggable";


export default /*#__PURE__*/_defineComponent({
  __name: 'DItemSelector',
  props: {
  source: { type: Array, default: () => [] },
  selectedItems: { type: Array, default: () => [] },
  valueField: { type: String, required: true },
  displayField: { type: String, required: true },
  leftHeaderText: { type: String, default: "列表" },
  rightHeaderText: { type: String, default: "已选择" },
},
  setup(__props, { expose }) {

const props = __props;



const refreshFlag = ref(0);

const realListData = ref<any[]>(JSON.parse(JSON.stringify(props.source)));
const realSelectedItems = ref<any[]>(JSON.parse(JSON.stringify(props.selectedItems)));

const leftSelectedItem: Map<string, any> = new Map();
const rightSelectedItem: Map<string, any> = new Map();

function doListUpdate() {
  refreshFlag.value += 1;
}

function setLeftSelection(data: any, event: MouseEvent) {
  if (!event.ctrlKey) {
    leftSelectedItem.clear();
  }
  leftSelectedItem.set(data[props.valueField], data);
  doListUpdate();
}

function setRightSelection(data: any, event: MouseEvent) {
  if (!event.ctrlKey) {
    rightSelectedItem.clear();
  }
  rightSelectedItem.set(data[props.valueField], data);
  doListUpdate();
}

function moveToRight() {
  if (!leftSelectedItem.size) {
    return;
  }
  leftSelectedItem.forEach((item) => {
    const pos = realListData.value.indexOf(item);
    if (pos === -1) {
      return;
    }
    realListData.value.splice(pos, 1);
    realSelectedItems.value.push(item);
  });
  leftSelectedItem.clear();
  doListUpdate();
}

function moveToLeft() {
  if (!rightSelectedItem.size) {
    return;
  }
  rightSelectedItem.forEach((item) => {
    const pos = realSelectedItems.value.indexOf(item);
    if (pos === -1) {
      return;
    }
    realSelectedItems.value.splice(pos, 1);
    realListData.value.push(item);
  });
  rightSelectedItem.clear();
  doListUpdate();
}

function moveAllToRight() {
  if (!realListData.value || !realListData.value.length) {
    return;
  }
  const allItems: any[] = ([] as any[]).concat(realListData.value);
  realListData.value = [];
  allItems.forEach((item) => realSelectedItems.value.push(item));
  leftSelectedItem.clear();
  doListUpdate();
}

function moveAllToLeft() {
  if (!realSelectedItems.value || !realSelectedItems.value.length) {
    return;
  }
  const allItems: any[] = ([] as any[]).concat(realSelectedItems.value);
  realSelectedItems.value = [];
  allItems.forEach((item) => realListData.value.push(item));
  rightSelectedItem.clear();
  doListUpdate();
}

function selectLeftAll(event: MouseEvent) {
  event.preventDefault();
  event.stopPropagation();

  leftSelectedItem.clear();
  realListData.value.forEach((data) => leftSelectedItem.set(data[props.valueField], data));

  doListUpdate();
}

function selectRightAll(event: MouseEvent) {
  event.preventDefault();
  event.stopPropagation();

  rightSelectedItem.clear();
  realSelectedItems.value.forEach((data) => rightSelectedItem.set(data[props.valueField], data));

  doListUpdate();
}

function getSelectedItems() {
  return realSelectedItems.value;
}

function getListData() {
  return realListData.value;
}

expose({
  getSelectedItems,
  getListData,
});

return { __sfc: true,props, refreshFlag, realListData, realSelectedItems, leftSelectedItem, rightSelectedItem, doListUpdate, setLeftSelection, setRightSelection, moveToRight, moveToLeft, moveAllToRight, moveAllToLeft, selectLeftAll, selectRightAll, getSelectedItems, getListData, VueDraggable }
}

})